var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { DEFAULT_MAX_WIDTH_COLUMN } from './helpers';
import { Button, BUTTON_VIEW } from "../../Button";
import { Checkbox } from "../Checkbox";
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../../StackView";
import { ControlSeparator } from "../ControlSeparator";
import { SPACING_L } from "../../helpers";
import { useTooltip } from "../../Tooltip";
import { TEXT_SIZE } from "../../Text";
import { onMouseEnterHandlerDecorator, TooltipText } from "../../Grid/cellRenderers/helpers";
var StyledCheckbox = styled(Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var ItemBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    grid-column: ", ";\n    grid-row: ", ";\n    max-width: ", ";\n\n    ", "\n"], ["\n    grid-column: ", ";\n    grid-row: ", ";\n    max-width: ", ";\n\n    ",
    "\n"])), function (_a) {
    var column = _a.column;
    return column;
}, function (_a) {
    var row = _a.row;
    return row;
}, DEFAULT_MAX_WIDTH_COLUMN, function (_a) {
    var column = _a.column;
    return column > 1 && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            padding-left: ", ";\n        "], ["\n            padding-left: ", ";\n        "])), SPACING_L);
});
function Item(_a) {
    var data = _a.data, column = _a.column, row = _a.row, onToggle = _a.onToggle, index = _a.index, selected = _a.selected;
    var ref = useRef(null);
    return useTooltip({
        delayTimeout: 500,
        maxWidth: DEFAULT_MAX_WIDTH_COLUMN,
        renderContent: function () { return React.createElement(TooltipText, { size: TEXT_SIZE.s }, data.name); },
        render: function (tooltipProps) {
            return (React.createElement(ItemBox, { column: column, row: row, "data-selector-id": "multiplechoice-item-" + index },
                React.createElement(StyledCheckbox, { checked: selected, labelTruncate: true, onChange: function () { return onToggle && onToggle(index); }, onMouseEnter: onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave, "data-selector-id": "multiplechoice-checkbox-" + index, ref: ref }, data.name)));
        }
    });
}
var getGridTemplateColumns = function (count) {
    var result = '';
    var c = count;
    while (c--) {
        result += '1fr ';
    }
    return result;
};
var Content = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: ", ";\n    overflow-x: auto;\n"], ["\n    display: grid;\n    grid-template-columns: ", ";\n    overflow-x: auto;\n"])), function (_a) {
    var columnCount = _a.columnCount;
    return getGridTemplateColumns(columnCount);
});
export function MultipleChoiceContent(_a) {
    var onSelectAll = _a.onSelectAll, onClearAll = _a.onClearAll, data = _a.data, canClearAll = _a.canClearAll, columnSize = _a.columnSize, canSelectAll = _a.canSelectAll, onToggleItem = _a.onToggleItem, isSelected = _a.isSelected;
    var total = data.length;
    var columnCount = Math.ceil(total / columnSize);
    return (React.createElement(StackView, { direction: STACK_DIRECTION.column },
        React.createElement(Content, { columnCount: columnCount }, data.map(function (item, idx) {
            var column = Math.floor(idx / columnSize) + 1;
            var row = columnSize + idx + 1 - columnSize * column;
            return (React.createElement(Item, { key: "" + (idx + 1), data: item, column: column, row: row, index: idx, onToggle: onToggleItem, selected: isSelected(idx) }));
        })),
        React.createElement(StackView, { gap: STACK_GAP.m, align: STACK_ALIGN.center },
            React.createElement(Button, { ui: BUTTON_VIEW.text, disabled: !canSelectAll, onClick: onSelectAll, "data-selector-id": "multiplechoice-select-all-control" }, "Select All"),
            React.createElement(ControlSeparator, null),
            React.createElement(Button, { ui: BUTTON_VIEW.text, disabled: !canClearAll, onClick: onClearAll, "data-selector-id": "multiplechoice-clear-all-control" }, "Clear All"))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=MultipleChoiceContent.js.map